import React from 'react'
import { GuiLiveItemPosition } from 'src/Libs/live-view'
import TopLeftArrow from './TopLeftArrow'
import TopRightArrow from './TopRightArrow'
import BottomLeftArrow from './BottomLeftArrow'
import BottomRightArrow from './BottomRightArrow'
import { SxProps } from '@mui/system'

interface Props {
  position?: GuiLiveItemPosition
  directionIsReversed?: boolean
  doNotFlow?: boolean
  sx?: SxProps
}

const CurvedArrow: React.FC<Props> = ({ position, directionIsReversed, doNotFlow, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'

  switch (position) {
    case 'top-left':
      return <TopLeftArrow direction={direction} sx={sx} />
    case 'top-right':
      return <TopRightArrow direction={direction} sx={sx} />
    case 'bottom-left':
      return <BottomLeftArrow direction={direction} sx={sx} />
    case 'bottom-right':
      return <BottomRightArrow direction={direction} sx={sx} />
    default:
      return <BottomLeftArrow direction={direction} sx={sx} />
  }
}

export default CurvedArrow
